// extracted by mini-css-extract-plugin
module.exports = {"control-bar":"ControlBar_control-bar__2IxXH","bar-main":"ControlBar_bar-main__gQYoH","btn-icon":"ControlBar_btn-icon__301jK"};